if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super()
        this.button = this.querySelector('button')
        this.atcButton = document.querySelector('#addtocart')
        this.init()
      }

      init() {
        this.addEventListener(
          'pointerdown',
          (event) => {
            const button = event.target.closest(
              '[data-sticky-atc-button]'
            )

            if (
              !button ||
              !this.contains(button) ||
              button.disabled
            ) {
              return
            }

            event.preventDefault()
            event.stopImmediatePropagation()

            this.clickATCButton(event)
          },
          true
        )

        document.addEventListener(
          'scroll',
          this.checkToActivateSticky.bind(this)
        )

        this.buildSizeSelector()
      }

      checkToActivateSticky() {
        this.atcButton = document.querySelector('#addtocart')

        if (!this.atcButton) return

        const buttonRect =
          this.atcButton.getBoundingClientRect()

        if (
          buttonRect.bottom <= 0 &&
          buttonRect.height !== 0
        ) {
          this.classList.add('active')
        } else {
          this.classList.remove('active')
        }
      }

      clickATCButton(event) {
        event.preventDefault()

        const stickySelect = this.querySelector(
          '#sticky-atc__select'
        )
        const selectedStickyOption =
          stickySelect?.selectedOptions[0]
        const selectedSize = selectedStickyOption?.value
        const selectedSizeAvailable =
          selectedStickyOption?.dataset.available === 'true'

        if (
          !selectedStickyOption ||
          !selectedSize ||
          !selectedSizeAvailable
        ) {
          return
        }

        const selectedSizeOption = document.querySelector(
          `[data-product-size] .option-selection-item[data-value="${CSS.escape(selectedSize)}"]`
        )

        if (
          !selectedSizeOption ||
          selectedSizeOption.classList.contains('disabled')
        ) {
          return
        }

        selectedSizeOption.click()

        setTimeout(() => {
          this.atcButton = document.querySelector('#addtocart')

          if (
            this.atcButton &&
            !this.atcButton.disabled
          ) {
            this.atcButton.click()
          }
        }, 250)
      }

      buildSizeSelector() {
        const sizeContainer = document.querySelector(
          '[data-product-size]'
        )

        if (!sizeContainer) return

        const buttonSelectWrapper = this.querySelector(
          '.sticky-atc__button-select-wrapper'
        )

        if (!buttonSelectWrapper) return

        const selectContainer =
          document.createElement('select')

        selectContainer.id = 'sticky-atc__select'

        const getSizeAvailability = (sizeValue) => {
          const config = window.pData?.config
          const product = config?.product
          const variants = product?.variants || []
          const availabilityMap = config?.availability

          if (!product?.options) return null

          const sizeOptionIndex = product.options.findIndex(
            (option) => option.name === 'Size'
          )

          if (sizeOptionIndex === -1) return null

          const optionKey = `option${sizeOptionIndex + 1}`

          return variants.some((variant) => {
            const matchesSize =
              String(variant[optionKey]) ===
              String(sizeValue)

            const isAvailable = availabilityMap
              ? Boolean(availabilityMap[variant.id])
              : Boolean(variant.available)

            return matchesSize && isAvailable
          })
        }

        const getUnavailableState = (
          productOption,
          sizeValue
        ) => {
          const unavailableInPDP =
            productOption.classList.contains('disabled') ||
            productOption.getAttribute(
              'aria-disabled'
            ) === 'true'

          const variantAvailability =
            getSizeAvailability(sizeValue)

          return (
            unavailableInPDP ||
            variantAvailability === false
          )
        }

        const setStickyOptionAvailability = (
          stickyOption,
          isUnavailable
        ) => {
          stickyOption.dataset.available = String(
            !isUnavailable
          )

          stickyOption.setAttribute(
            'aria-disabled',
            String(isUnavailable)
          )

          stickyOption.classList.toggle(
            'sticky-atc__option--unavailable',
            isUnavailable
          )
        }

        const sizeOptions = sizeContainer.querySelectorAll(
          '[data-product-option]'
        )

        sizeOptions.forEach((productOption) => {
          const value =
            productOption.getAttribute('data-value')

          if (!value) return

          const stickyOption =
            document.createElement('option')

          const isUnavailable = getUnavailableState(
            productOption,
            value
          )

          stickyOption.classList.add(
            'sticky-atc__option'
          )
          stickyOption.value = value
          stickyOption.textContent = value

          setStickyOptionAvailability(
            stickyOption,
            isUnavailable
          )

          selectContainer.append(stickyOption)
        })

        buttonSelectWrapper.prepend(selectContainer)

        const syncSizeAvailability = () => {
          const currentSizeContainer =
            document.querySelector('[data-product-size]')

          if (!currentSizeContainer) return

          const productSizeOptions =
            currentSizeContainer.querySelectorAll(
              '[data-product-option]'
            )

          productSizeOptions.forEach(
            (productOption) => {
              const value =
                productOption.getAttribute('data-value')

              if (!value) return

              const stickyOption =
                selectContainer.querySelector(
                  `.sticky-atc__option[value="${CSS.escape(value)}"]`
                )

              if (!stickyOption) return

              const isUnavailable =
                getUnavailableState(
                  productOption,
                  value
                )

              setStickyOptionAvailability(
                stickyOption,
                isUnavailable
              )
            }
          )

          const activeProductSize =
            currentSizeContainer.querySelector(
              '[data-product-option].active'
            )

          if (activeProductSize) {
            selectContainer.value =
              activeProductSize.getAttribute(
                'data-value'
              )
          } else if (
            !selectContainer.value &&
            selectContainer.options.length
          ) {
            selectContainer.selectedIndex = 0
          }

          const selectedStickyOption =
            selectContainer.selectedOptions[0]

          const stickyButton = this.querySelector(
            '[data-sticky-atc-button]'
          )

          if (!stickyButton) return

          const selectedSizeAvailable =
            selectedStickyOption?.dataset.available ===
            'true'

          const coverageContainer =
            document.querySelector(
              "[data-option='Coverage']"
            )

          const coverageVisible =
            coverageContainer &&
            coverageContainer.offsetParent !== null &&
            coverageContainer.style.display !== 'none'

          const coverageOptions = coverageVisible
            ? coverageContainer.querySelectorAll(
                '.option-selection-item'
              )
            : []

          const coverageActive = coverageVisible
            ? coverageContainer.querySelector(
                '.option-selection-item.active'
              )
            : null

          const needsCoverage =
            coverageOptions.length > 0 &&
            !coverageActive

          stickyButton.classList.remove(
            'sticky-atc__button--needs-selection'
          )

          if (!selectedSizeAvailable) {
            stickyButton.setAttribute(
              'disabled',
              'disabled'
            )
            stickyButton.textContent = 'Out of Stock'
          } else if (needsCoverage) {
            stickyButton.setAttribute(
              'disabled',
              'disabled'
            )
            stickyButton.classList.add(
              'sticky-atc__button--needs-selection'
            )
            stickyButton.textContent = 'Select Coverage'
          } else {
            stickyButton.removeAttribute('disabled')
            stickyButton.textContent = 'Add to Bag'
          }
        }

        const scheduleAvailabilitySync = () => {
          syncSizeAvailability()

          setTimeout(syncSizeAvailability, 0)
          setTimeout(syncSizeAvailability, 150)
          setTimeout(syncSizeAvailability, 500)
        }

        selectContainer.addEventListener(
          'change',
          (event) => {
            this.clickActiveSize(event)
            scheduleAvailabilitySync()
          }
        )

        scheduleAvailabilitySync()

        const availabilityObserver =
          new MutationObserver(
            scheduleAvailabilitySync
          )

        availabilityObserver.observe(sizeContainer, {
          attributes: true,
          subtree: true,
          attributeFilter: [
            'class',
            'aria-disabled'
          ]
        })

        document.addEventListener(
          'lspace:option-selected',
          scheduleAvailabilitySync
        )

        document.addEventListener(
          'product:OptionSelected',
          scheduleAvailabilitySync
        )

        document.addEventListener(
          'variant:changed',
          scheduleAvailabilitySync
        )
      }

      clickActiveSize(event) {
        const value = event.currentTarget.value

        if (!value) return

        const variantSelector = document.querySelector(
          `[data-product-size] [data-product-option][data-value="${CSS.escape(value)}"]`
        )

        if (variantSelector) {
          variantSelector.click()
        }
      }
    }
  )
}